var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistAdded = function SvgWishlistAdded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.615 1.5h-7.23A2.902 2.902 0 0 0 2.49 4.395v10.568c0 1.35.968 1.92 2.153 1.267l3.66-2.033c.39-.217 1.02-.217 1.402 0l3.66 2.033c1.185.66 2.153.09 2.153-1.268V4.396A2.913 2.913 0 0 0 12.615 1.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.193 8.25 1.125 1.125 3-3",
    opacity: 0.4
  })));
};
export default SvgWishlistAdded;